import { SVGProps } from 'react';

export const ExportIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width='12'
      height='12'
      viewBox='0 0 12 12'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...props}>
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M6 1.125C6.20711 1.125 6.375 1.29289 6.375 1.5V7.34467L7.98483 5.73484C8.13128 5.58839 8.36872 5.58839 8.51517 5.73484C8.66161 5.88128 8.66161 6.11872 8.51517 6.26516L6.26516 8.51517C6.11872 8.66161 5.88128 8.66161 5.73484 8.51517L3.48484 6.26516C3.33839 6.11872 3.33839 5.88128 3.48484 5.73484C3.63128 5.58839 3.86872 5.58839 4.01516 5.73484L5.625 7.34467V1.5C5.625 1.29289 5.79289 1.125 6 1.125ZM1.5 7.875C1.70711 7.875 1.875 8.04289 1.875 8.25V9.375C1.875 9.78921 2.21079 10.125 2.625 10.125H9.375C9.78921 10.125 10.125 9.78921 10.125 9.375V8.25C10.125 8.04289 10.2929 7.875 10.5 7.875C10.7071 7.875 10.875 8.04289 10.875 8.25V9.375C10.875 10.2034 10.2034 10.875 9.375 10.875H2.625C1.79657 10.875 1.125 10.2034 1.125 9.375V8.25C1.125 8.04289 1.29289 7.875 1.5 7.875Z'
      />
    </svg>
  );
};
